import React, {useEffect, useState} from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	useInfiniteQuery,
	useMutation, 
	QueryClient, 
	QueryClientProvider, 
	useQueryClient
} from 'react-query';
import PropTypes from "prop-types";
import get from "lodash/get";

import { Chip } from "../atoms/chip";
import { SubAvatar } from "../atoms/sub-avatar";
import Loader from "../atoms/loader";
import { parseUrl } from "query-string";

import {
	//getFreshComments,
	createCMUser,
	fetchComments, 
	postComment, 
	deleteComment,
	editComment, 
	updateLike,
	updateFeature,
	getTimestamp,
	reportComment,
	fetchReplies
} from "../../../server/handlers/cartoon-mango"
import { Link } from "@quintype/components";
import assetify from "@quintype/framework/assetify";
import LockIcon from "./icons/lock.png"
import SendIcon from "./icons/send.png"
import MenuIcon from "./icons/menu.png"
import AvatarIcon from "./icons/avatar.png"
import LikeIcon from "./icons/like.png"
import LikedIcon from "./icons/liked.png"
import ReplyIcon from "./icons/reply.png"
import EditIcon from "./icons/edit.png"
import DeleteIcon from "./icons/delete.png"
import ReportIcon from "./icons/report.png"
import EmptyArt from "./icons/empty.svg"

import "./comment-widget.m.css"
import { SubscribePopup } from "../molecules/popup/subscribe-popup";

function CommentWidgetBase({story, config, member, activeSubscription}) {

	const [isSubscriber, setIsSubscriber] = React.useState(true);
	const [inputText, setInputText] = React.useState("");
	const [count, setCount] = useState(0);
	const [comments, setComments] = useState(null)
	const [isLoading, setLoading] = useState(false);
	const [commentPage, setCommentPage] = useState(1);
	const [userDetails, setUserDetails] = useState(null)
	
	React.useEffect(()=>{
		member && activeSubscription && 
		createCMUser(member, activeSubscription)
			.then(res=>res && res.data && setUserDetails(res.data))
	}, [count, member, activeSubscription])

	const queryClient = new QueryClient({
		defaultOptions: {
		  queries: {
			staleTime: 0,
			refetchInterval: 10000,
			refetchIntervalInBackground: true
		  },
		},
	})

	return (
		<QueryClientProvider client={queryClient}>
			<Comments story={story} member={member} activeSubscription={activeSubscription} count={count} setCount={setCount} userDetails={userDetails}/>
		</QueryClientProvider>
	);
}

const Comments = ({story, member, activeSubscription, count, setCount, userDetails}) => {

	const {
		data,
		error,
		fetchNextPage,
		hasNextPage,
		isFetching,
		isFetchingNextPage,
		refetch,
		status,
	} = useInfiniteQuery(['comments', {storyID:story.id}], fetchComments, {
			getNextPageParam: (lastPage, pages) =>{
				if(lastPage && lastPage.data.items.length===5)
					return lastPage.data.next_page_cursor
			}
	})

	if (status==='success' && data.pages[0]){
		setCount(data.pages[0].data.items.length)
	}

	const [showReplyfor, setShowReplyFor] =  useState(null)


	return(
		<div styleName="wrapper">
				<h3 styleName = "section-title">Comments</h3>

				<InputForm refetch={refetch} story={story} member={member} activeSubscription={activeSubscription}/>

				<hr/>

				{count===0 && status!=='loading' &&
					<div styleName="empty-state">
						<img src={assetify(EmptyArt)}/>
						<i>Be the first one to comment</i>
					</div>
				}	
			
				{
					status==='loading'? (
						<span styleName="loader"><br/><Loader color="#ec2227"/></span>
					) : status ==='error'? (
						<p>Error : {error.message}</p>
					) : (
						<React.Fragment>
							{data.pages.map((page, i)=>{
								return <React.Fragment key={i}>
									{page && page.data.items.map(item=>{
										return !item.is_deleted && <CommentBody showReplyfor={showReplyfor} setShowReplyFor={setShowReplyFor} story={story} item={item} member={member} userSubscription={activeSubscription} reply={false} userDetails={userDetails} key={item.id}/>
									})}
								</React.Fragment>
							})}
							<div styleName="load-more">
								
								{hasNextPage && !isFetchingNextPage &&
									<button onClick={()=>fetchNextPage()} >
										Load more comments 
									</button>
								}
								{
									isFetchingNextPage && <span styleName="loader"><br/><Loader color="#ec2227"/></span>
								}
							</div>
						</React.Fragment>	
					)
				}
		</div>
	)
}

const CommentBody = ({
	story,
	item,
	member,
	userSubscription,
	reply,
	showReplyfor,
	setShowReplyFor,
	userDetails
}) => {

	const queryClient = useQueryClient()
	const {
		data,
		error,
		fetchNextPage,
		hasNextPage,
		isFetching,
		isFetchingNextPage,
		status,
		refetch
	} =  useInfiniteQuery(['replies', {commentID:item.id}], fetchReplies, {
			
			getNextPageParam: (lastPage, pages) =>{
				if(hasNextPage!==false){
					return lastPage.data.next_page
				} else{
					return false
				}
			},
			enabled:false
	})

	const [isReply, setIsReply] = useState(false);
	const [isEdit, setIsEdit] = useState(false)
	const [isValid, setIsValid] = useState(false)

	const deleteMutation = useMutation(deleteComment, {
		onSuccess: () => {
			queryClient.invalidateQueries(['comments'])
		}
	})

	const likeMutation = useMutation(updateLike, {
		onSuccess: () => {
			queryClient.invalidateQueries(['comments'])
		}
	})

 	const handleDelete = (id) => {
		item.is_deleted = 1;
		deleteMutation.mutate({id:id})
		//deleteComment(id)
	} 

	const handleLike = () => {
		
		likeMutation.mutate({id:item.id})
		item.liked_count = item.is_liked?item.liked_count-1:item.liked_count+1
		item.is_liked = !item.is_liked;		
	}
	const handleReport = () => {
		reportComment(item.id)
	} 
 
	const handleFeature = (id) =>{
		updateFeature(item.id, item.is_featured) 
		item.is_featured=!item.is_featured
	} 

	const handleReplyPagination = () => {
		setShowReplyFor(item.id);
		refetch()
	}

	return !item.is_deleted && (
			<div styleName={`comment-wrapper ${item.is_featured ? "feature": item.is_author? "author":""}`} key={item.id}>
				{((!item.is_deleted && !isEdit && member && item.user_id===member.id) || (userDetails && userDetails.is_author===1)) &&
					<Dropdown  
						item={item} 
						member = { member }
						handleDelete={handleDelete}
						handleReport = {handleReport} 
						handleFeature = {handleFeature}
						setIsEdit={setIsEdit}
						userDetails={userDetails}
						key={item.id}
					/>
				}

				{!item.is_deleted && !isEdit &&
					<div styleName="comment-body">
						<img src={item.avatar_url ? assetify(item.avatar_url):assetify(AvatarIcon) } 
							styleName="comment-avatar" 
							style={!item.avatar_url|| isValid ?{padding:"8px"}:null}
							onError={(event) => {
								event.target.src = assetify(AvatarIcon)
								setIsValid(true)
							}  }
						/>
						<div styleName="text-wrapper">
							<h5 styleName="comment-name">
								{item.user_name || `NL User ${item.user_id}`} 
								{item.subscription_details && item.subscription_details.length>0 && <SubAvatar groupId = {item.subscription_details[0].subscription_group_id}/>}
								<small styleName="comment-time">{getTimestamp(new Date(item.created_at), new Date())}</small>
							</h5>
							
							{item.is_author===1 && <><Chip background="#ec2227" color="white">NL Team</Chip>&nbsp;</>}
							{item.is_featured===1 && <Chip background="#663399" color="white">Featured </Chip>} 
							{/* {item.user_email && includes("newslaundry") && <Chip>NL Team</Chip>} */}

							<p styleName="comment-text">{item.comments}</p>
						</div>
					</div>
				
				}

				{ isEdit && 
					<InputForm 
						member = { member }
						activeSubscription={userSubscription}
						commentID = {item.id}
						isEdit = {isEdit}
						setIsEdit = {setIsEdit}
						editText={item.comments} 
						story={story}
						item={item}
					/>
				}

				{!item.is_deleted && !isEdit &&
					<div styleName="actions">
						<small styleName="action" onClick={()=>{
							handleLike()
						}}>
							<img styleName = "action-logo"  
								src={assetify(item.is_liked? LikedIcon : LikeIcon)}
							/>
							{item.liked_count}
						</small>
						{!reply&&<small styleName="action" onClick={()=>{setIsReply(!isReply)}}>
							<img styleName="action-logo" src={assetify(ReplyIcon)}/>
							<b>Reply</b>
						</small>}
					</div>
				}

				{isReply &&  
					<div styleName="reply-input-wrapper">
						<InputForm item={item} story={story} commentID={item.id} isReply = {true} setShowReplyFor={setShowReplyFor} setIsReply={setIsReply} member={member} activeSubscription={userSubscription} key={item.id}/>
					</div>
				}

				<div styleName="reply-wrapper">
					{/* {
						showReplyfor!==item.id && item.replies && item.replies.map(reply=>{
	
							return(
								!reply.is_deleted && <CommentBody 
										item={reply}  
										member = { member }
										userSubscription={userSubscription}
										key={reply.id}
										reply={true}
										userDetails={userDetails}
									/>
							)
						})
					} */}
					{
						data && showReplyfor===item.id &&
						<React.Fragment>
							{data.pages.map((page, i)=>{
								return <React.Fragment key={i}>
									{page.data.items.map(reply=>{
										
										return !reply.is_deleted && <CommentBody item={reply}  
										member = { member }
										userSubscription={userSubscription}
										key={reply.id}
										reply={true}/>
									})}
								</React.Fragment>
							})}
						
						</React.Fragment>	
					}
					
					{item.reply_count>0  &&  showReplyfor!==item.id &&
						<div styleName="load-more" onClick={handleReplyPagination}>
							<span>Show {item.reply_count>1 &&item.reply_count} {item.reply_count>1?"replies":"reply"}
								<i class="material-icons-outlined">expand_more</i>
							</span>
						</div>
					}
					{showReplyfor===item.id && status!=='loading' &&
						<div styleName="load-more" onClick={()=>setShowReplyFor(null)}>
							<span>Hide replies<i className="material-icons-outlined">expand_less</i></span>
						</div>
					}
					{status==='loading' && 
						<span styleName="loader"><br/><Loader color="#ec2227"/></span>
					}	
				</div>				
		</div>
	)
}

/*
Input form component 
*/
const InputForm = (props) => {
	
	const [text, setText] = useState(props.editText||"");
	const [error, setError] = useState(null);
	const [showSubscribePopup, setShowSubscribePopup] = useState(false)
	const queryClient = useQueryClient()
	const textAreaRef = React.useRef(null);

	const member = useSelector(state => state.member);
	const authHost= useSelector(state => get(state,["qt", "config", "publisher", "publisher", "auth_host"], null));
	const currentPath = useSelector(state => get(state, ["qt", "currentPath"], ""));
	const params = parseUrl(currentPath);
	const callbackUrl = get(params, ["query", "callback-url"], global.location && global.location.origin);
	const redirectUrl = get(params, ["query", "redirect-url"], global && global.location && global.location.href);
	const url =`${authHost}/authenticate?redirect-url=${redirectUrl}&callback-url=${callbackUrl}&auth-page=${authHost}/user-login`;
	const redirectToLogin = () => {
		window.location=url
	};

	const postMutation = useMutation(postComment, {
		onSuccess: (data, variables) => {
			setText("")
			props.setIsReply && props.setIsReply(false)
			queryClient.invalidateQueries(['comments'])
			!props.setIsReply && props.refetch({ refetchPage: (page, index) => index === 0 })
		},
	})

	const editMutation = useMutation(editComment, {
		
		onSuccess : data => {
			queryClient.invalidateQueries(['comments'])
			setText("")
			props.setIsEdit(false)
		}
	})

	//Handle edit cancellation on esc key press
	const handleKeyDown = (e) => {
		if(e.keyCode===27 && props.isEdit){
			props.setIsEdit(false)
		}
	}

	const handleSubmit = async(e, text, setText) => {
		
		e.preventDefault()
	
		if(!props.activeSubscription){
			setShowSubscribePopup(true)
			return
		}
		else if(text.trim().length<=2 || text.trim()==="" ){
			setError("Oops! Text must be longer")
			return
		}
		if(props.isReply){
			props.setShowReplyFor(null)
			props.item.reply_count=props.item.reply_count+1
		}

		postMutation.mutate({inputText:text, storyID:props.story.id, parentID: props.isReply?props.commentID:null})
	}

	const handleEdit = async(e, text) => {

		e.preventDefault();
		props.item.comments=text;
		editMutation.mutate({inputText:text.trim(), id:props.commentID})
	}
	
	return (
		<React.Fragment>
			<form styleName="upper" onSubmit={
				(e)=>props.isEdit ?
					handleEdit(e, text)
				:
					handleSubmit(e, text, setText)
			}>
				<img 
					src={props.member && props.member["avatar-url"]?assetify(props.member["avatar-url"]):assetify(AvatarIcon)} 
					styleName="comment-input-avatar"
					style={props.member && props.member["avatar-url"]?null:{padding:"8px"}}
				/>
				
					<textarea rows = {1} placeholder="Enter feedback / question / suggestion" 
						onChange={(e)=>{
							setText(e.target.value)
							const target = e.target ;
							textAreaRef.current.style.height = "40px";
							textAreaRef.current.style.height = `${target.scrollHeight}px`;
							//this.parentNode.dataset.replicatedValue = this.value
						}}
						onKeyDown={handleKeyDown}
						ref = {textAreaRef}
						value={text}

						styleName="inp"
					>
						{ props.isEdit&&<button>cancel</button>}
					</textarea> 
	

				{/*<input type="file" id="actual-input" name="filename" hidden/>
				<label for="actual-input" styleName="upload">
					<img src="https://img.icons8.com/material-outlined/48/000000/image.png"/>
				</label>*/}

				<button styleName = "btn">
					{!postMutation.isLoading && !editMutation.isLoading ?
						<i className="material-icons-outlined" >{props.activeSubscription?"send":"lock"}</i>
						:
						<Loader color="white"/>
					}
					{/* {isSubscriber?
						<img src={assetify(LockIcon)} onClick={()=>alert('Oops! \nYou need to be a subscriber to use NL comments')}/>
					:
					} 
					*/}
				</button>
		
			</form>
			{error && <small styleName="err-msg">{error}</small>}
			{!(props.subscription || props.member) &&
				<div styleName="prompt-text">
					
					{!props.activeSubscription && 
						<small styleName="err-cta">
							We take comments from subscribers only!
							&nbsp;<a><Link href="/subscription?ref=comment">Subscribe now</Link></a> to post comments!
						</small>
					}&nbsp;
					{!props.member && 
						<small styleName="err-cta"><br/>Already a subscriber? 
							&nbsp;<a onClick={redirectToLogin}>Login</a>
						</small>
					}
				</div>
			}
				
			{showSubscribePopup && <SubscribePopup showModal={showSubscribePopup} setShowModal={setShowSubscribePopup}/>}
		</React.Fragment>
	);
};




/*
Dropdown menu component 
*/
const Dropdown = (props) => {

	const [isDropdown, setIsDropdown] = useState(false)
	const dropdownMenu = React.useRef(null);
	
	//Handle drop down state
	React.useEffect(() => {
	
		// Function for click event
		function handleOutsideClick(event) {
			if (dropdownMenu.current && !dropdownMenu.current.contains(event.target)) {
			setIsDropdown(false)
			}
		}
		
		// Adding click event listener
		document.addEventListener("click", handleOutsideClick);
	}, [dropdownMenu]);

	return(
		<span styleName="dropdown" ref={dropdownMenu}>
			<img styleName = "drop-btn" 
				src={assetify(MenuIcon)} 
				onClick={()=>setIsDropdown(true)}
			/>
			{isDropdown && props.item && props.member &&
				<div styleName="dropdown-content">
					{props.item.user_id===props.member.id && 
						<a onClick={()=>props.setIsEdit(true)}>
							<img src={assetify(EditIcon)}/>	
							<span>Edit</span>
						</a>
					}
					
						{/* <a onClick={handleReport}>
							<img  src={assetify(ReportIcon)}/>
							<span>Report</span>
						</a> */}
					
					{props.item.user_id===props.member.id &&
						<a onClick={()=>props.handleDelete(props.item.id)}>
							<img src={assetify(DeleteIcon)}/>
							<span>Delete</span>
						</a>
					}
					{props.userDetails && props.userDetails.is_author===1 &&
						<a onClick={()=>{props.handleFeature(); setIsDropdown(false)}}>
							<img  src={assetify(ReportIcon)}/>
							<span>Feature</span>
						</a>
					}
				</div>
			}
		</span>
		)
}

CommentWidgetBase.propTypes = {
	story: PropTypes.object
};
const mapStateToProps = state => {
	return {
		config: state.qt.config || {},
		member: get(state, ["member"], null),
		isSubscriber: get(state, ["isSubscribedUser", "userHasSubscription"], null),
		activeSubscription:get(state, ["isSubscribedUser", "userSubscription"], null)&& get(state, ["isSubscribedUser", "userSubscription"], null).filter(item=>item.active===true).length>0?get(state, ["isSubscribedUser", "userSubscription"], null).filter(item=>item.active===true):null
	};
};
export const CommentWidget = connect(mapStateToProps, {})(CommentWidgetBase);
